import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import { usePrivacyBanner } from './usePrivacyBanner';
import { getLegalLink } from '../legal/getLegalLink';
import HubletLocation from './HubletLocation';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { useIsSU0004Variation } from '../hooks/useIsSU0004Variation';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTermsOfServiceLink = styled.span.withConfig({
  displayName: "CreateAccountTermsOfService__StyledTermsOfServiceLink"
})(({
  theme
}) => {
  return {
    color: theme.color['text-core-default'],
    textDecoration: 'underline',
    WebkitFontSmoothing: 'auto',
    MozOsxFontSmoothing: 'auto'
  };
});
const TermsOfServiceLinkWrapper = props => {
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledTermsOfServiceLink, {
      children: props.children
    })
  }));
};
const CreateAccountTermsOfService = () => {
  const {
    createAccountTextI18nLabel,
    handleClickTermsOfService,
    handleClickDeveloperTermsOfService,
    handleConnectTermsOfUseClick,
    handleClickPrivacyPolicy
  } = usePrivacyBanner();
  const {
    layoutType
  } = useLayoutTemplate();
  const isSU0004Variation = useIsSU0004Variation();
  const {
    currentStep
  } = useCurrentStep();
  const isSU0004ToSStyling = isSU0004Variation && (currentStep === Step.Review || currentStep === Step.HubletSelection);
  const termsOfServiceOptions = {
    termsOfServiceLink: /*#__PURE__*/_jsx(TermsOfServiceLinkWrapper, {
      external: true,
      hideExternalLinkIcon: true,
      href: getLegalLink('terms-of-service'),
      onClick: handleClickTermsOfService,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "legal.termsOfServiceLink"
      })
    }, "gdprPolicy"),
    developerTermsOfServiceLink: /*#__PURE__*/_jsx(TermsOfServiceLinkWrapper, {
      external: true,
      hideExternalLinkIcon: true,
      href: 'https://legal.hubspot.com/developer-terms',
      onClick: handleClickDeveloperTermsOfService,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "legal.developerTermsOfServiceLink"
      })
    }, "gdprPolicyDevelopers"),
    developerCustomerTermsOfServiceLink: /*#__PURE__*/_jsx(TermsOfServiceLinkWrapper, {
      external: true,
      hideExternalLinkIcon: true,
      href: getLegalLink('terms-of-service'),
      onClick: handleClickTermsOfService,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "legal.developerCustomerTermsOfServiceLink"
      })
    }, "gdprPolicyCustomers"),
    connectTermsOfServiceLink: /*#__PURE__*/_jsx(TermsOfServiceLinkWrapper, {
      external: true,
      hideExternalLinkIcon: true,
      href: getLegalLink('website-terms-of-use'),
      onClick: handleConnectTermsOfUseClick,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "legal.connectTermsOfServiceLink"
      })
    }, "gdprPolicy"),
    hubspotPrivacyPolicyLink: /*#__PURE__*/_jsx(TermsOfServiceLinkWrapper, {
      external: true,
      hideExternalLinkIcon: true,
      href: getLegalLink('privacy-policy'),
      onClick: handleClickPrivacyPolicy,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "legal.hubspotPrivacyPolicyLink"
      })
    }, "gdprPolicy")
  };
  return /*#__PURE__*/_jsxs(Text, {
    color: "text-core-default",
    marginInlineEnd: isSU0004ToSStyling ? undefined : '400',
    textAlign: layoutType === LayoutType.SidePanel ? 'right' : 'center',
    textWrap: "balance",
    typography: isSU0004ToSStyling ? 'body-100' : 'detail-200',
    children: [/*#__PURE__*/_jsx(HubletLocation, {}), /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: createAccountTextI18nLabel,
      options: termsOfServiceOptions
    })]
  });
};
export default CreateAccountTermsOfService;